import React from "react";
import Input from "@components/forms/Input";

const VerificationForm = ({ t, verificationCode, setVerificationCode, handleVerifyCode, handleLoginAttempt, loading }) => {
  return (
    <>
      <div className="mb-4">
        <Input
          value={verificationCode}
          handleChange={(e) => setVerificationCode(e.target.value)}
          placeholder={t("verification_code")}
          type="text"
        />
      </div>

      <div className="d-grid mb-3">
        <button
          type="button"
          className="btn p-3 btn-blue"
          onClick={handleVerifyCode}
          disabled={!verificationCode || loading}
        >
          {loading ? t("loading") : t("verify")}
        </button>
      </div>

      <div className="d-grid">
        <button
          type="button"
          className="btn text-blue border-blue"
          onClick={() => handleLoginAttempt(true)}
          disabled={loading}
        >
          {t("send_again")}
        </button>
      </div>
    </>
  );
};

export default VerificationForm;
